import * as React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { Row, Col } from 'reactstrap';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { RootState } from '@src/app/_redux/root-reducer';
import { actionCreators as paymentsActionCreators } from '@src/app/accounts/payments/actions';
import { getAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';
import { withRouter } from 'react-router';
import { getCurrencyFormatter } from '@src/app/_global/utility/formatters';
import { LoadingView } from '@src/app/_global/components/Loading';
import { bindActionCreators, Dispatch } from 'redux';
import '../payments.scss';

interface State {
  widgetProdIdAlias: any;
  widgetConfigId: any;
  displayError: any;
  showSubmitButton: any;
  loading: boolean;
}
export interface PaymentProps {
  reset: () => void;
  previousPage: any;
  onCancel: any;
  intl: intlShape;  
  clientConfig: any;
  adminConfig: any;
  paymentsCancel: () => void;
  paymentAmount: any;
  selectedOrders: any;
  availableActions: any;
  billToAddress: any;
  submitPaymentHandler: any;
  paymentsData: any;
  directViewLogin: boolean;
  loggedInCustomer: any;
}
class PageTwoForm extends React.Component<PaymentProps> {
  state: State = {
    widgetProdIdAlias: '',
    widgetConfigId: '',
    displayError: '',
    showSubmitButton: false,
    loading: false,
  };

  paymentCapture: any;

  constructor(props: any) {
    super(props);
    this.handleCancel = this.handleCancel.bind(this);
    this.updatePaymentDetails = this.updatePaymentDetails.bind(this);
    this.handleAltPmtAuth = this.handleAltPmtAuth.bind(this);
  }

  componentDidMount() {
    let availableActions = getAdminConfigTableItem(
      this.props.adminConfig,
      this.props.clientConfig,
      'AvailableActions',
      this.props.selectedOrders[0].prodIdAlias
    );
    let widgetId = (availableActions.Preferences && availableActions.Preferences.paymentPaymentWidgetConfigId ? 
      availableActions.Preferences.paymentPaymentWidgetConfigId : '');
    const config =             {
      configId:  widgetId,
      origin: window.location.origin,
      prodIdAlias: this.props.selectedOrders[0].systemCode !== 'CORE' ? this.props.selectedOrders[0].prodIdAlias : this.props.loggedInCustomer.prodIdAlias,
      isCore: this.props.selectedOrders[0].systemCode === 'CORE',
    };

    this.paymentCapture = new PaymentCapture(config);
    this.toggleSubmitButton = this.toggleSubmitButton.bind(this);
    this.paymentCapture.on('form-validated', this.toggleSubmitButton);
    this.paymentCapture.on('ready', this.updatePaymentDetails);
    this.paymentCapture.on('transaction-completed', this.handlePaymentSuccess);
    this.paymentCapture.on('alt-payment-authorized', this.handleAltPmtAuth);
    this.setState({
      widgetProdIdAlias:  this.props.selectedOrders[0].systemCode !== 'CORE' ? this.props.selectedOrders[0].prodIdAlias : this.props.loggedInCustomer.prodIdAlias,
      widgetConfigId: widgetId,
      displayError: '',
      loading: false,
    });
  }
  handleAltPmtAuth(data: any) {
    if (data.pwRespMessage === 'Success') {
      this.setState({
        showSubmitButton: true
      });
    }
  }

  toggleSubmitButton(valid: any) {
    this.setState({
      showSubmitButton: valid
    });
  }

  onSubmitRequest = (values: any) => {
    values.preventDefault();
    this.setState({showSubmitButton: false, loading: true});
    this.paymentCapture.performTransaction()
    .catch((error) => {
      console.log('GC-PC performTransactionError responseCode: ' + error.pwRespCode  + ' msg: ' + error.pwRespDescription );
      this.setState({ page: 2, displayError: 'An error has occurred. Please try again.', showSubmitButton: true, loading: false }); 
    });
  }
  handlePaymentSuccess = (data) => {
    if (data.pwRespMessage === 'Success') {
      this.props.submitPaymentHandler(data);
    } else {
      console.log('GC-PC handlePaymentSuccess responseCode: ' + data.pwRespCode  + ' msg: ' + data.pwRespDescription );
      this.setState({ page: 2, displayError: 'An error has occurred. Please try again.', showSubmitButton: true, loading: false});
    }
  }
  formatDollarsToCents = (value) => {
    if (value && value.includes('.')) {
      value = value.substring(0, value.indexOf('.') + 3);
    }
  
    return value ? Math.round(parseFloat(value) * 100) : 0;
  }

  async updatePaymentDetails() {
    let generatedAuthorizationReferenceId = this.props.selectedOrders[0].billToAccountNumber + '-' + new Date().valueOf();
    let transCurrencyCode = this.props.selectedOrders[0].systemCode === 'CORE' ? (this.props.selectedOrders[0].currencyCode === 'CAD' ? '124' : '840') : '840'; // default to US $
    let pmtAmt = this.formatDollarsToCents(this.props.paymentAmount).toString();
    await this.paymentCapture.updatePaymentDetails({
      countryCode: this.props.billToAddress.countryCode,
      transCurrencyCode: transCurrencyCode,
      transAmount: pmtAmt,
      creditCard: {
        billingPostalCode: this.props.billToAddress.postalCode,
        billingAddressLine1:  this.props.billToAddress.address1,
        billingState:  this.props.billToAddress.state,
        billingCity:  this.props.billToAddress.city,
        cardHolderName:  this.props.billToAddress.name
      },
      altpayment: {
        customAuthorizationReferenceId: generatedAuthorizationReferenceId
      }
    }).catch((errors) => {
        console.log('PC processPayment Error' + errors);
    });
  }
  handleCancel() {
    this.setState({
      widgetProdIdAlias: '',
      widgetConfigId: '',
      displayError: '',
      autoRenewOptIn: false 
    });

     this.props.paymentsCancel();
  }
  getSubmitButtonLabel() {
    let availableActions = getAdminConfigTableItem(
      this.props.adminConfig,
      this.props.clientConfig,
      'AvailableActions',
      this.props.selectedOrders[0].prodIdAlias
    );
    return availableActions.Preferences && availableActions.Preferences.customPayLabel ? availableActions.Preferences.customPayLabel : 'Pay';
}
  render() {
    const { 
      previousPage, 
      onCancel, 
      paymentAmount, 
      directViewLogin,
    } = this.props;

    return (
      <form className="payments-form" onSubmit={this.onSubmitRequest}>
        <div className="payments-wrapper">
          <div className="small-text mb-2 bold">Payment amount: {getCurrencyFormatter(this.props.selectedOrders.length > 0 && this.props.selectedOrders[0].systemCode === 'CORE' 
                                          ? this.props.selectedOrders[0].currencyCode : 'USD').format(paymentAmount)}</div>
          {this.state.displayError.length > 0 && (<span className="text-danger bold mt-3 mb-3">{this.state.displayError}</span>)} 
          <Row> 
            <Col className="" xs={12} sm={12} md={6}>
              <div id="payment-capture"></div>
            </Col>
          </Row>
          { this.state.loading  ? (
            <div>
            <LoadingView loadingText="Loading..."/>
            </div>
          ) : (
            <div className="button-ct">
              <button className="btn btn-primary" disabled={!this.state.showSubmitButton}  type="submit">
                <FormattedMessage
                  id="payment.submit"
                  description="Pay"
                  defaultMessage={this.getSubmitButtonLabel()}
                />
              </button>
              <button
                type="button"
                className="mr-2 ml-2 btn btn-light previous"
                onClick={previousPage}
              >
              <i className="mr-2 fa fa-angle-double-left" aria-hidden="true" />
              <FormattedMessage
                id="app.previous"
                description="payment previous button"
                defaultMessage="Previous"
              />
              </button>
              {!directViewLogin && (
                <button
                  className="btn btn-light ml-2"
                  type="button"
                  onClick={this.props.onCancel}
                >
                  <FormattedMessage
                    id="app.cancel"
                    description="payment cancel button"
                    defaultMessage="Cancel"
                  />
                </button>
              )}
            </div>
          )}
        </div>
      </form>
    );
  }
}

let redx = reduxForm({
  form: 'payment',
  destroyOnUnmount: false,
  enableReinitialize: false,
  forceUnregisterOnUnmount: true,
})(PageTwoForm);

const mapStateToProps = (state: RootState) => ({
  clientConfig: state.clientConfig,
  adminConfig: state.adminConfig,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      paymentsCancel : paymentsActionCreators.paymentsCancel,
    },
    dispatch,
  );

redx = connect(mapStateToProps, mapDispatchToProps)(redx);

export const PageTwo = injectIntl(withRouter(redx));
